import ConfirmModal from '../components/ConfirmModal';

export interface UnsavedChangesModalProps {
  open: boolean;
  /** Was geändert wurde, z. B. „Bericht" */
  label?: string;
  onDiscard: () => void;
  onStay: () => void;
}

/**
 * Rückfrage vor dem Verlust ungespeicherter Änderungen (Regel „Dokument-Navigation" R5).
 * Eine Fassung für Seiten, Dialoge und den Verlassen-Schutz des Portals — gleiche Texte
 * überall.
 */
export function UnsavedChangesModal({ open, label, onDiscard, onStay }: UnsavedChangesModalProps) {
  const what = (label ?? '').trim();
  return (
    <ConfirmModal
      open={open}
      layer="top"
      danger
      title="Änderungen verwerfen?"
      message={what
        ? `Es gibt ungespeicherte Änderungen (${what}). Beim Verlassen gehen sie verloren.`
        : 'Es gibt ungespeicherte Änderungen. Beim Verlassen gehen sie verloren.'}
      confirmLabel="Verwerfen"
      cancelLabel="Weiter bearbeiten"
      onClose={onStay}
      onConfirm={onDiscard}
    />
  );
}
